import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-bg text-text flex items-center justify-center px-4">
      <div className="text-center">
        <h1 className="text-3xl font-semibold">404</h1>
        <p className="mt-2 text-muted">Page not found</p>
        <Link className="mt-4 inline-block text-primary font-medium" to="/">
          Go home
        </Link>
      </div>
    </div>
  );
}
